import { CognitoUser } from 'amazon-cognito-identity-js';
import { SignOutParams, UpdateCognitoContext } from './types';
import cognitoStorageAdapter from '../storage/cognitoStorageAdapter';

const signOut =
  (user: CognitoUser, updateCognitoContext: UpdateCognitoContext) =>
    ({ onSuccess, onFailure }: SignOutParams) => {
      const resetState = () => {
        updateCognitoContext({
          userAttributes: undefined,
          user: undefined,
          userSession: undefined,
          authenticated: false,
          newPasswordRequired: false,
        });
      };

      if (!user) {
        console.warn('[SignOut] No user to sign out');
        resetState();
        onSuccess();
        return;
      }

      try {
        const rememberMe = cognitoStorageAdapter.getRememberMe();
        console.debug('[SignOut] Signing out user:', user.getUsername(), '| rememberMe:', rememberMe);

        if (rememberMe) {
          // When "remember me" is enabled, skip user.signOut() which clears all
          // tokens from storage. We keep the tokens in localStorage so the SDK
          // can restore a full session (id + access + refresh) on the next visit.
          // The React state reset below is sufficient to end the current session.
          console.debug('[SignOut] Keeping tokens in localStorage for auto-login');
        } else {
          // No "remember me" — clear all tokens from storage
          user.signOut();
          console.debug('[SignOut] Tokens cleared from storage');
        }

        resetState();
        onSuccess();
      } catch (error) {
        console.error('[SignOut] Sign out failed:', error);
        resetState();
        onFailure(error instanceof Error ? error.message : 'Unknown error during sign out');
      }
    };

export default signOut;